import { FlightType } from "src/Modules/Flights/constants";
import { getValue } from "src/utility";
import { FLIGHT_INCLUSIONS } from "src/Modules/Flights/constants/JourneyDetails";
import classNames from "classnames";
import { FC, HTMLAttributes } from "react";

const FlightInclusions: FC<{ flight: FlightType; className?: string; itemClassName?: string } & HTMLAttributes<HTMLDivElement>> = ({
  flight,
  className,
  itemClassName,
  ...props
}) => {
  return (
    <div className={classNames("flex flex-wrap gap-3 md:gap-5", className)} {...props}>
      {FLIGHT_INCLUSIONS.map((inclusion) => {
        const value = getValue(flight, inclusion.path);
        const displayValue = inclusion?.transform ? inclusion?.transform(value) : value;
        if (displayValue) {
          return (
            <div className={classNames("flex flex-1 items-center gap-1 whitespace-nowrap", itemClassName)} key={`${inclusion.key}`}>
              <span className="aspect-square w-5">{inclusion.icon}</span>
              <span className="text-sm">{displayValue}</span>
              <span className="text-sm">{inclusion.title}</span>
            </div>
          );
        }
      })}
    </div>
  );
};

export default FlightInclusions;
